// extracted by mini-css-extract-plugin
module.exports = {"headerSearch":"Search_headerSearch__Iza3G","includeFormerEmployees":"Search_includeFormerEmployees__6YysI","checkbox":"Search_checkbox__2zjqd","checked":"Search_checked__3vG8G"};